export default "__VITE_ASSET__DFQMWNJ8__"